module.exports = __webpack_public_path__ + "static/img/site-logo.28732d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/site-logo.png
// module id = /K6P
// module chunks = 1